import { render, staticRenderFns } from "./ClassParticipants.vue?vue&type=template&id=2ad4a190"
import script from "./ClassParticipants.vue?vue&type=script&lang=js"
export * from "./ClassParticipants.vue?vue&type=script&lang=js"
import style0 from "./ClassParticipants.vue?vue&type=style&index=0&id=2ad4a190&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports